import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { captureLandingContext } from './lib/attribution';
import './index.css';

// Capture sign-up attribution (UTM, referrer, landing path) the moment the visitor
// loads the app, BEFORE any client-side routing. Persists to localStorage so it
// survives the magic-link sign-in redirect. Written to Supabase at first sign-in.
captureLandingContext();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
